export default theme => ({
  // Privacy
  privacy: {
    marginTop: theme.spacing.unit * 5,
    '& strong': {
      fontWeight: theme.typography.fontWeightMedium
    },
    '& h1': {
      ...theme.typography.display2,
      margin: `0 0 ${theme.spacing.unit * 3}px`
    },
    '& h3': {
      ...theme.typography.title,
      margin: `0 0 ${theme.spacing.unit * 2}px`
    },
    '& p': {
      ...theme.typography.body1,
      margin: `0 0 ${theme.spacing.unit * 2}px`
    },
    '& ul': {
      margin: 0,
      paddingLeft: theme.spacing.unit * 3,
      listStyle: 'lower-alpha'
    },
    '& li': {
      ...theme.typography.body1,
      margin: `0 0 ${theme.spacing.unit * 2}px`
    }
  }
});



// WEBPACK FOOTER //
// ./src/pages/Privacy/styles.js